import { render, staticRenderFns } from "./point.vue?vue&type=template&id=1875bd39"
import script from "./point.vue?vue&type=script&lang=js"
export * from "./point.vue?vue&type=script&lang=js"
import style0 from "./point.vue?vue&type=style&index=0&id=1875bd39&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports